import { Stack, Typography } from '@mui/material';
import {AuditInformation} from '@store/audits/audits-information/audits-information.model';

interface NeedProps {
  auditInformation: AuditInformation;
}

const Need = (props: NeedProps) => {
  return (
    <Stack direction="row" alignItems="center" height="100%">
      <Stack sx={{
        backgroundColor: '#E9EBEE',
        borderRadius: '1px',
        padding: '6px 10px',
        width: 'fit-content'
      }}>
        <Typography fontSize="12px" fontWeight={400} color="#192133">
          {props.auditInformation.description}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Need;
